import { render, staticRenderFns } from "./PaymentGroupList.vue?vue&type=template&id=36ac0902&"
import script from "./PaymentGroupList.vue?vue&type=script&lang=js&"
export * from "./PaymentGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports